// 加载中图标
import { CircularProgress } from '@mui/material';
const LoadingIcon = ({sizes = 16, sx = { color: '#fff' }}) => {
  return <CircularProgress size={sizes} sx={sx} />;
};
export default LoadingIcon;
